import React from "react";
import Navbar from "./global-components/navbar-v3";
import PageHeader from "./global-components/page-header";
import AboutUsYourCareerContent from "./section-components/about-us-your-career";
import CallToActionV1 from "./section-components/call-to-action-v1";
import Footer from "./global-components/footer";

const AboutUsYourCareerPage = () => {
  return (
    <div>
      <Navbar />
      <PageHeader headertitle="Our opportunities" />
      <AboutUsYourCareerContent />
      <CallToActionV1 />
      <Footer />
    </div>
  );
};

export default AboutUsYourCareerPage;
